/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import type {
  UseMutationOptions,
  UseMutationResult,
  QueryClient,
} from "@tanstack/react-query"
import { mutationOptions, useMutation } from "@tanstack/react-query"

import fetch from "~/backend/axiosClient"
import type {
  RequestConfig,
  ResponseErrorConfig,
  ResponseConfig,
} from "~/backend/axiosClient"

import type {
  DeleteProductPageComponentMutationResponse,
  DeleteProductPageComponentPathParams,
} from "../types/DeleteProductPageComponent.ts"

export const deleteProductPageComponentMutationKey = () =>
  [{ url: "/v1/organization-settings/product-page-components/:id" }] as const

export type DeleteProductPageComponentMutationKey = ReturnType<
  typeof deleteProductPageComponentMutationKey
>

/**
 * @summary Delete product page component
 * {@link /v1/organization-settings/product-page-components/:id}
 */
export async function deleteProductPageComponent(
  id: DeleteProductPageComponentPathParams["id"],
  config: Partial<RequestConfig> & { client?: typeof fetch } = {}
) {
  const { client: request = fetch, ...requestConfig } = config

  const res = await request<
    DeleteProductPageComponentMutationResponse,
    ResponseErrorConfig<Error>,
    unknown
  >({
    method: "DELETE",
    url: `/v1/organization-settings/product-page-components/${id}`,
    ...requestConfig,
  })
  return res
}

export function deleteProductPageComponentMutationOptions(
  config: Partial<RequestConfig> & { client?: typeof fetch } = {}
) {
  const mutationKey = deleteProductPageComponentMutationKey()
  return mutationOptions<
    ResponseConfig<DeleteProductPageComponentMutationResponse>,
    ResponseErrorConfig<Error>,
    { id: DeleteProductPageComponentPathParams["id"] },
    typeof mutationKey
  >({
    mutationKey,
    mutationFn: async ({ id }) => {
      return deleteProductPageComponent(id, config)
    },
  })
}

/**
 * @summary Delete product page component
 * {@link /v1/organization-settings/product-page-components/:id}
 */
export function useDeleteProductPageComponent<TContext>(
  options: {
    mutation?: UseMutationOptions<
      ResponseConfig<DeleteProductPageComponentMutationResponse>,
      ResponseErrorConfig<Error>,
      { id: DeleteProductPageComponentPathParams["id"] },
      TContext
    > & { client?: QueryClient }
    client?: Partial<RequestConfig> & { client?: typeof fetch }
  } = {}
) {
  const { mutation = {}, client: config = {} } = options ?? {}
  const { client: queryClient, ...mutationOptions } = mutation
  const mutationKey =
    mutationOptions.mutationKey ?? deleteProductPageComponentMutationKey()

  const baseOptions = deleteProductPageComponentMutationOptions(
    config
  ) as UseMutationOptions<
    ResponseConfig<DeleteProductPageComponentMutationResponse>,
    ResponseErrorConfig<Error>,
    { id: DeleteProductPageComponentPathParams["id"] },
    TContext
  >

  return useMutation<
    ResponseConfig<DeleteProductPageComponentMutationResponse>,
    ResponseErrorConfig<Error>,
    { id: DeleteProductPageComponentPathParams["id"] },
    TContext
  >(
    {
      ...baseOptions,
      mutationKey,
      ...mutationOptions,
    },
    queryClient
  ) as UseMutationResult<
    ResponseConfig<DeleteProductPageComponentMutationResponse>,
    ResponseErrorConfig<Error>,
    { id: DeleteProductPageComponentPathParams["id"] },
    TContext
  >
}
